export const GET_PROVINCIA_START = 'GET_PROVINCIA_START';
export const GET_PROVINCIA_SUCCESS = 'GET_PROVINCIA_SUCCESS';
export const GET_PROVINCIA_FAILURE = 'GET_PROVINCIA_FAILURE';

export const GET_CANTON_START = 'GET_CANTON_START';
export const GET_CANTON_SUCCESS = 'GET_CANTON_SUCCESS';
export const GET_CANTON_FAILURE = 'GET_CANTON_FAILURE';
